export default {
  name: 'gmk-ta-royal-alpha',
  override: {
    KC_ESC: 'accent',
    KC_ENT: 'accent',
    KC_SPC: 'accent'
  }
};
